<main class="ax-w-full ax-p-4">
  <ax-form #loginForm validationMessageMode="tooltip">
    <div class="ax-grid ax-grid-cols-1 ax-gap-4">
      <ax-form-field class="ax-w-full">
        <!-- شماره موبایل -->
        <!-- <ax-label>{{ 'profile.phoneNumber' | translate | async }}{{ settingData.agencyId !== 1900010 ? '/' + ('profile.email' | translate | async) : '' }}</ax-label> -->
        <ax-label>{{ settingData.agencyId === 1900010 ? ('profile.phoneNumber' | translate | async) :
          settingData.registerMethodTypeName ? settingData.registerMethodTypeName : ('profile.phoneNumber' | translate |
          async)+'/' +('profile.email' | translate | async) }}</ax-label>

        <ax-text-box dir="ltr" [(ngModel)]="_loginObj.username">
          <!-- لطفا شماره موبایل خود را وارد کنید -->
          <ax-validation-rule rule="required"
            [message]="('profile.phoneNumberRequired' | translate | async)!"></ax-validation-rule>
        </ax-text-box>
      </ax-form-field>
      <ax-form-field class="ax-w-full">
        <!-- کلمه عبور -->
        <ax-label>{{ 'profile.password' | translate | async }}</ax-label>
        <ax-password-box dir="ltr" [(ngModel)]="_loginObj.password">
          <!-- لطفا رمز عبور خود را وارد نمایید -->
          <ax-validation-rule rule="required"
            [message]="('profile.passwordRequired' | translate | async)!"></ax-validation-rule>
        </ax-password-box>
      </ax-form-field>

      <div class="ax-relative ax-flex ax-h-20 ax-w-full ax-rounded ax-border ax-border-default">
        <!-- کد‌امنیتی -->
        <img [src]="'data:image/png;base64,' + _captchaCodeObject.image" [alt]="'profile.captcha' | translate | async"
          class="ax-h-full ax-w-full ax-rounded ax-object-cover" />
        <ax-button class="ax-absolute ax-bottom-[-0.5rem] ax-end-[-0.5rem] ax-rounded-full ax-sm" color="secondary"
          (onClick)="getCaptchaGenerate()" [disabled]="isLoading">
          <ax-prefix *ngIf="!isLoading">
            <i class="fa-solid fa-rotate-right"></i>
          </ax-prefix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-button>
      </div>
      <ax-form-field class="ax-w-full">
        <!-- کد‌امنیتی -->
        <ax-label>{{ 'profile.captcha' | translate | async }}</ax-label>
        <ax-text-box dir="ltr" [(ngModel)]="_loginObj.captchaCode">
          <!-- کد‌امنیتی را وارد نمایید -->
          <ax-validation-rule rule="required"
            [message]="('profile.captchaRequired' | translate | async)!"></ax-validation-rule>
        </ax-text-box>
      </ax-form-field>
      <!-- ورود -->
      <ax-button [text]="'profile.login' | translate | async" class="ax-w-full" (onClick)="handleLoginClick()"
        color="primary" [disabled]="isLoading">
        <ax-suffix>
          <ax-loading *ngIf="isLoading"></ax-loading>
        </ax-suffix>
      </ax-button>
    </div>
  </ax-form>

  <div class="ax-mt-4 ax-flex ax-w-full ax-justify-between ax-gap-4">
    <!-- ایجاد حساب کاربری -->
    <ax-button [text]="'profile.signup' | translate | async" look="outline" (onClick)="registerPopup(0)"
      color="primary"></ax-button>
    <!-- فراموشی کلمه عبور -->
    <ax-button [text]="'profile.forgotPassword' | translate | async" look="outline" class="!ax-decoration-dashed"
      color="primary" (onClick)="registerPopup(1)"></ax-button>
  </div>
</main>